module.exports = __webpack_public_path__ + "img/sMrHippo_193x205.c256cd5d.png";